import { Row, Col, Image, Card } from "antd";

import Logo from "@assets/images/logo/logo.png";

export default function Welcome() {
  return (
    <Card
      style={{
        width: "100%",
        border: "none",
        background: "transparent",
      }}
      bodyStyle={{ padding: "24px 32px" }}
    >
      <Row gutter={[20, 0]}>
        <Col md={24} span={24}>
          <div style={{ textAlign: "center" }}>
            <Image src={Logo} preview={false} width={56} style={{ marginBottom: 16 }} />
            <h2 style={{
              fontSize: 28,
              fontWeight: 700,
              color: "#1f2937",
              margin: "0 0 8px 0",
              whiteSpace: "nowrap"
            }}>
              Welcome to Copilotly!
            </h2>
            <p style={{
              fontSize: 16,
              color: "#6b7280",
              margin: "0 0 20px 0"
            }}>
              Let's take a quick tour to get you started
            </p>

            <video
              src="https://s3.amazonaws.com/copilotly.default/onboarding.mp4"
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 12,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
              }}
            />

            <div style={{
              background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
              padding: 16,
              borderRadius: 12,
              marginTop: 20,
              textAlign: "left"
            }}>
              <p style={{
                margin: 0,
                fontSize: 15,
                color: "#0369a1",
                fontWeight: 500
              }}>
                <span style={{ marginRight: 8 }}>🎯</span>
                <strong>Quick start:</strong> Pin the extension, reload your page, then select any text to generate!
              </p>
            </div>

            <a
              href="https://youtu.be/uTJNGLoBoCU?si=ufRJpWHr4ez92EX3"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                fontSize: 14,
                padding: "10px 20px",
                borderRadius: 8,
                color: "#fff",
                background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                marginTop: 16,
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                fontWeight: 500,
                boxShadow: "0 2px 8px rgba(79, 70, 229, 0.3)"
              }}
            >
              <span>▶</span> Watch full tutorial
            </a>
          </div>
        </Col>
      </Row>
    </Card>
  );
}
